module.exports = __webpack_public_path__ + "img/icon_moreapi_index.12c5390e.svg";